import { Field, reduxForm, initialize } from 'redux-form'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import InputField from 'client/features/form/components/InputField.jsx'
import CheckboxesField from 'client/features/form/components/CheckboxesField.jsx'
import { reportsSearchChange } from 'client/features/reports/actions'
import REPORT from 'constant/REPORT'
import Select from 'react-select'
import { getSelectReportsOptions } from 'client/features/reports/lib'
import _ from 'underscore'

class ReportsFilters extends Component {
    constructor() {
        super()
    }
    handleSubmit() {
        setTimeout(() => this.props.submit(), 0) 
    }

    search(data) {
        this.props.dispatch(reportsSearchChange({ search: data ? data : null }))
    }
    
    render() {
        const { handleSubmit, valid, submitting, error, pristine, reportsFilters } = this.props
        const values = reportsFilters && reportsFilters.values ? reportsFilters.values : {}
        const countries = []
        this.props.reports.all.forEach((report) => {
            const client = report.client
            if (client && client.country && !_.findWhere(countries, { value: client.country }))
                countries.push({ value: client.country, label: client.country })
        })
        return (
            <form onSubmit={ handleSubmit } onChange={ handleSubmit }>
                <div className='row m-t-8'>
                    <div className='col-md-8'>
                        <h5>Filters</h5>
                        <Field
                            component={ CheckboxesField }
                            fields={ [...REPORT.types].map(type => ({
                                ...type,
                                label: type.label.fr
                            })) }
                            onChange={ this.handleSubmit.bind(this) }
                            values={ values.type }
                            name='type'
                            initialValues={ this.props.initialValues.type }
                            live
                        /> 
                        <Field
                            component={ CheckboxesField }
                            fields={ countries }
                            onChange={ this.handleSubmit.bind(this) }
                            values={ values.clientCountry }
                            name='clientCountry'
                            initialValues={ this.props.initialValues.clientCountry }
                            live
                        /> 
                        <Field
                            component={ CheckboxesField }
                            fields={ REPORT.states }
                            onChange={ this.handleSubmit.bind(this) }
                            values={ values.states }
                            name='states'
                            initialValues={ this.props.initialValues.clientCountry }
                            live
                        /> 
                    </div>
                    <div className='col-md-4'>
                        {
                            !this.props.user.limited &&
                            <div>
                            <h5>Recherche</h5>
                            <Select
                                className='m-b-12'
                                name='form-field-name'
                                label='Client'
                                value={ this.props.reports.search }
                                placeholder='Search... (hives & clients)'
                                options={ getSelectReportsOptions(this.props.clients, this.props.reports.all) }
                                onChange={ this.search.bind(this) }
                                noResultsText='Not found.'
                            />
                            </div>
                        }
                    </div>
                </div>
            </form>
        )
    }
}

ReportsFilters.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
} 

ReportsFilters = reduxForm({
    form: 'reportsFilters'
})(ReportsFilters)

const mapStateToProps = (state) => {
    const initialValues = state.reports.filters
    return {
        reports: state.reports,
        initialValues,
        clients: state.client.all,
        reportsFilters: state.form.reportsFilters
    }
}

export default connect(mapStateToProps)(ReportsFilters)


// WEBPACK FOOTER //
// ./src/client/features/reports/components/Filters.jsx